import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { AppShellComponent } from './app-shell/app-shell.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { AuthModule } from 'src/app/pages/auth/auth.module';
import { ToasterComponent } from './toaster/toaster.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { WarningModelComponent } from './warning-model/warning-model.component';
import { CommonComponentModule } from '../common-component/common-component.module';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    HeaderComponent,
    AppShellComponent,
    FooterComponent,
    ToasterComponent,
    WarningModelComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    AuthModule,
    MatSnackBarModule,
    CommonComponentModule,
    ReactiveFormsModule,
  ],
  exports: [
    AppShellComponent,
  ]
})
export class AppShellModule { }
